import { AppLocale } from 'utils/parseAnyLocale';
import { LabelGenerator } from '../types';
import { gbLabelGenerators } from '../en-GB';
import { CsProductCardsProduct, CsProductCardsProductLabel } from 'components/ProductCards/types';
import { Product } from 'api/dbs/models';

/**
 * @deprecated The method will be removed as soon as b2cProductCardLabel feature flag is permanently turned on
 */
export const getProductLabels = (locale: AppLocale) => {
  let generators: LabelGenerator[] | undefined;
  if (locale === 'en-GB') {
    generators = gbLabelGenerators;
  }
  return (product: Product, productCardsProduct?: CsProductCardsProduct) =>
    generators
      ?.map((fn) => fn(product, productCardsProduct))
      .filter(Boolean)
      .splice(0, 2) as CsProductCardsProductLabel[] | undefined;
};
